"use client";

// Lecteur YouTube en mode « sans cookie » (youtube-nocookie.com) : YouTube ne
// dépose rien tant que la vidéo n'est pas lancée. Il n'est affiché qu'après un
// clic sur la vignette (ArticleVideo), d'où la lecture automatique : un seul
// clic suffit pour regarder.
export default function VideoYouTube({ video, title = "" }) {
    return (
        <div className="aspect-w-16 aspect-h-9">
            <iframe
                src={`https://www.youtube-nocookie.com/embed/${encodeURIComponent(video)}?autoplay=1&rel=0`}
                title={title || "YouTube"}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                referrerPolicy="strict-origin-when-cross-origin"
                className="w-full rounded-xl"
            />
        </div>
    );
}
